import { memo } from 'react'
import './index.scss'
import { REPORTS } from '../Data/data'
import { useLocation, useNavigate } from 'react-router-dom'
import { usePermissions } from '../../../hooks/usePermissions'

const ReportNavbar = memo(() => {
  const navigate = useNavigate()
  const location = useLocation()

  const { checkPermission } = usePermissions()

  return (
    <div className="ReportNavbar">
      {Object.keys(REPORTS)
        .filter((id: string) => {
          const { permissions } = REPORTS[id]
          const permission = permissions.map((p) => checkPermission(p.name, p.inverted))
          return permission.length ? !permission.includes(false) : true
        })
        .map((id: string) => {
          const { name, url } = REPORTS[id]
          const reportUrl = `/reports${url}`
          const isSelected = reportUrl === location.pathname
          return (
            <div
              className={`ReportNavbar__report${isSelected ? ' selected' : ''}`}
              role="button"
              tabIndex={0}
              onClick={() => navigate(reportUrl)}
            >
              {name}
            </div>
          )
        })}
    </div>
  )
})

export default ReportNavbar
